import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import MenuRoute from './routes/MenuRoute.jsx';
import PlayRoute from './routes/PlayRoute.jsx';
import GalleryRoute from './routes/GalleryRoute.jsx';
import CreditsRoute from './routes/CreditsRoute.jsx';

/**
 * @file T11 UI shell. Routing only: the engine lifecycle lives entirely in
 * `GameCanvas.jsx` (ref-owned, StrictMode-safe), and every HUD piece lives under
 * `hud/`. See those files' headers for the lifecycle contract and the exact bus
 * events each one reads/writes.
 *
 * The `/editor` route is GONE with the procedural creature system it existed to
 * drive. Enemies are authored files now — `src/game/enemies/*.enemy.json` plus
 * art under `public/` — and the review surface for them is the dev scene
 * `/play/bestiary`, which needs no route of its own (dev scenes auto-discover).
 *
 * `/credits` is the sound attribution, and it is a REAL ROUTE rather than a
 * pause-menu panel for one reason: one clip ships under CC BY 4.0, where the
 * credit is a licence CONDITION, and a licence notice that can only be read by
 * starting a level and opening a menu is a licence notice nobody can cite.
 */
export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MenuRoute />} />
        <Route path="/play/:levelId" element={<PlayRoute />} />
        <Route path="/gallery/:levelId" element={<GalleryRoute />} />
        <Route path="/credits" element={<CreditsRoute />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
